import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CTA from 'Src/components/buttons/CTA';
import { Flex } from 'Src/components/layout/Flex';
import { FormField } from 'Src/feature/form/FormField';

import { StandardDiscountWithSchedules } from './discountService';

import styles from './DiscountPromoCodeInput.module.scss';

const sectionId = 'DiscountPromoCode';

interface DiscountPromoCodeInputProps {
  getDiscountFromPromoCode: (code: string) => StandardDiscountWithSchedules | undefined;
  onApply: (promoCode: string) => void;
  inputProps: {
    placeholder: string;
  }
}

const DiscountPromoCodeInput: FC<DiscountPromoCodeInputProps> = ({
  getDiscountFromPromoCode,
  onApply,
  inputProps,
}) => {
  const { t } = useTranslation();
  const [promoCode, promoCodeSet] = useState('');
  const [errors, errorsSet] = useState([] as string[]);
  const hasErrors = Boolean(errors.length);

  const onSearch = (newPromoCode: string) => {
    if (newPromoCode) {
      if (getDiscountFromPromoCode(newPromoCode)) {
        errorsSet([]);
      } else {
        errorsSet([t('discount.validation.missingPromoCode', { code: newPromoCode })]);
      }
    } else {
      errorsSet([]);
    }
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newPromoCode = event.target.value;
    promoCodeSet(newPromoCode);
    onSearch(newPromoCode);
  };

  return (
    <Flex fullWidth gap="xxs">
      <FormField
        {...inputProps}
        className={styles.textInput}
        variant="underline"
        type="text"
        fullWidth
        value={promoCode}
        onChange={onChange}
        error={hasErrors}
        errorText={errors.join(', ')}
      />
      {
        !hasErrors && Boolean(promoCode.length) && (
          <CTA
            className={styles.button}
            label={t('labels.apply')}
            color="primary"
            onClick={() => {onApply(promoCode);}}
          />
        )
      }
    </Flex>
  );
};

export { DiscountPromoCodeInput, sectionId };
export type { DiscountPromoCodeInputProps };
